import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import { useCallback } from 'react'
import PageBuilderModel from '@v4/store/builderStore/models/PageBuilder.model'
import AppStore from '@v4/store/appStore'
import { useSectionId } from '@v4/components/common/SectionItem'
import ThemeSelector from '@v4/utils/selectors/ThemeSelector'

const useFieldFocus = ({ metaData, categoryId, index, itemKey, active }) => {
	const { group } = metaData?.config || {}
	const name = metaData?.metaKey
	const {
		setFocusedField,
		setActiveItemKey,
		setActiveSectionId,
		setActiveCategoryId,
	} = PageBuilderSelector.useActions()
	const sectionId = useSectionId()
	const activeSectionId = PageBuilderSelector.useActiveSectionId()
	const isSectionActive = activeSectionId === sectionId
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const isQuestionBuilderMode = PageBuilderSelector.useIsQuestionsMode()
	const isThemeGalleryActive = ThemeSelector.useIsGalleryActive()
	const { updateGallery: updateThemeGallery } = ThemeSelector.useActions()
	const sidebarMode = PageBuilderSelector.useSidebarMode()
	const activeItemKey = PageBuilderSelector.useMetaActiveItemKey({
		sectionId,
		group: 'items',
	})
	const activeCategoryId = PageBuilderSelector.useMetaActiveCategoryId({
		sectionId,
		group: 'category',
	})

	const isSectionsMode = sidebarMode === PageBuilderModel.SIDEBAR_MODE.SECTIONS

	const handleFocus = useCallback(
		event => {
			event.preventDefault()
			event.stopPropagation()

			if (isBuilderMode && isThemeGalleryActive) {
				updateThemeGallery({ active: false })
			}

			if (!group || (isBuilderMode && isQuestionBuilderMode)) return

			if (!isSectionActive || !isSectionsMode) {
				setActiveSectionId({ id: sectionId })
			}
			if (itemKey) {
				setActiveItemKey({ sectionId, group, itemKey })
			} else if (activeItemKey) {
				setActiveItemKey({ sectionId, group: 'items', itemKey: null })
			}

			if (categoryId) {
				setActiveCategoryId({ sectionId, group, categoryId })
			} else if (activeCategoryId) {
				setActiveCategoryId({ sectionId, group: 'category', categoryId: null })
			}

			setFocusedField({
				sectionId,
				name,
				categoryId,
				index,
				group,
				repeatable: !!itemKey,
				scrolling: PageBuilderModel.SCROLLING_TYPE.SIDEBAR,
			})
		},
		[
			isBuilderMode,
			isThemeGalleryActive,
			group,
			isQuestionBuilderMode,
			isSectionActive,
			isSectionsMode,
			itemKey,
			activeItemKey,
			categoryId,
			activeCategoryId,
			setFocusedField,
			sectionId,
			name,
			index,
			updateThemeGallery,
			setActiveSectionId,
			setActiveItemKey,
			setActiveCategoryId,
		],
	)

	return {
		handleFocus: isBuilderMode || active ? handleFocus : undefined,
	}
}

export default useFieldFocus
